import React from 'react';

const Contact: React.FC = () => {
  return (
    <div className="page contact">
      <div className="container contact-container">
        <h1>Get in Touch</h1>
        
        {/* Contact Methods Section */}
        <section className="contact-methods">
          <div className="contact-card">
            <div className="contact-card-content">
              <i className="fa-solid fa-envelope fa-3x"></i>
            </div>
            <h3>Email Contact</h3>
            <p>Reach out directly for inquiries, training requests, or collaboration opportunities.</p>
            <a href="mailto:contact@pawelpiwosz.net" className="contact-button">
              <span>contact@pawelpiwosz.net</span>
            </a>
          </div>

          <div className="contact-card">
            <div className="contact-card-content">
              <i className="fa-solid fa-calendar fa-3x"></i>
            </div>
            <h3>Schedule a Consultation</h3>
            <p>Book a consultation call to discuss your training needs and how I can help your team.</p>
            <a href="https://calendly.com/pawelpiwosz/consultation" target="_blank" rel="noopener noreferrer" className="contact-button">
              <span>Schedule via Calendly</span>
            </a>
          </div>
        </section>

        {/* LinkedIn Contact Section */}
        <section className="contact-card">
          <div className="contact-card-content">
            <i className="fab fa-linkedin fa-3x"></i>
            <h2>Connect on LinkedIn</h2>
            <p>Let's connect professionally and stay in touch through LinkedIn. I share insights about DevOps, cloud technologies, and team collaboration.</p>
            <a href="https://www.linkedin.com/in/pawelpiwosz" target="_blank" rel="noopener noreferrer" className="contact-button">
              Connect on LinkedIn
            </a>
          </div>
        </section>

        {/* Other Platforms Section */}
        <section className="other-platforms">
          <h2>Find Me On Other Platforms</h2>
          <div className="platform-links">
            <a href="https://github.com/pawelpiwosz" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-github fa-2x"></i>
              <span>GitHub</span>
            </a>
            <a href="https://www.youtube.com/@devopsinagileway" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-youtube fa-2x"></i>
              <span>YouTube channel</span>
            </a>
            <a href="https://www.youtube.com/@ohmycloud-pl" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-youtube fa-2x"></i>
              <span>YouTube podcast</span>
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Contact;